// Table to display the annotated transcript
import React from 'react';

import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { Paper } from "@mui/material";

// Helper function to convert seconds to mm:ss format
// Manually converts seconds to mm:ss format instead of using Date/ISO because we need to handle negative times as well
const formatTime = (seconds) => {
  if (!seconds && seconds !== 0) return '';
  
  const numSeconds = parseFloat(seconds);
  const isNegative = numSeconds < 0;
  const absSeconds = Math.abs(numSeconds);
  const minutes = Math.floor(absSeconds / 60);
  const remainingSeconds = Math.floor(absSeconds % 60);
  const formattedTime = `${minutes.toString().padStart(2, '0')}:${remainingSeconds.toString().padStart(2, '0')}`;
  
  return isNegative ? `-${formattedTime}` : formattedTime;
};

const TranscriptTable = ({ segments }) => {
  return (
    <div style={{ marginTop: "50px", marginBottom: "50px" }}>
      <TableContainer component={Paper} style={{ maxHeight: 800, overflow: 'scroll' }}>
        <Table aria-label="segments table">
          <TableHead>
            <TableRow>
              <TableCell style={{ padding: '5px' }}>Statement ID</TableCell>
              <TableCell style={{ padding: '5px' }}>Speaker ID</TableCell>
              <TableCell style={{ padding: '5px' }}>Speaker Type</TableCell>
              <TableCell style={{ padding: '5px' }}>Chat or Speech</TableCell>
              <TableCell style={{ padding: '5px' }}>Start</TableCell>
              <TableCell style={{ padding: '5px' }}>End</TableCell>
              <TableCell style={{ padding: '5px' }}>Text</TableCell>
              <TableCell style={{ padding: '5px' }}>Talk Move (Probability)</TableCell>
              <TableCell style={{ padding: '5px' }}>BCI (Probability)</TableCell>
              <TableCell style={{ padding: '5px' }}>QTF</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {segments.slice(0, 20).map((segment, index) => (
              <React.Fragment key={index}>
                {segment.map((item, subIndex) => (
                  <TableRow key={subIndex}>
                    <TableCell style={{ padding: '5px' }}>{item.id}</TableCell>
                    <TableCell style={{ padding: '5px' }}>{item.participantId}</TableCell>
                    <TableCell style={{ padding: '5px' }}>
                      {(() => {
                        const speakerTypeAnnotation = item.annotations && item.annotations.find(a => a.annotationType === "speakerTypeIdentification");
                        if (speakerTypeAnnotation) {
                          const prob = Math.max(...speakerTypeAnnotation.probability.map(Number)).toFixed(3);
                          return `${item.speakerType} (${prob})`;
                        }
                        return item.speakerType;
                      })()}
                    </TableCell>
                    <TableCell style={{ padding: '5px' }}>{item.type}</TableCell>
                    <TableCell style={{ padding: '5px' }}>{formatTime(item.start)}</TableCell>
                    <TableCell style={{ padding: '5px' }}>{formatTime(item.end)}</TableCell>
                    <TableCell style={{ padding: '5px' }}>{item.text}</TableCell>
                    <TableCell style={{ padding: '5px' }}>
                    {(() => {
                      const talkMoveAnnotation = item.annotations && item.annotations.find(annotation => annotation.annotationType === "talk_move");
                      if (talkMoveAnnotation) {
                        const label = talkMoveAnnotation.values[0];
                        const probability = talkMoveAnnotation.probability;
                        const prob = Array.isArray(probability)
                          ? Math.max(...probability.map(Number)).toFixed(3)
                          : parseFloat(probability).toFixed(3);
                        return `${label} (${prob})`;
                      }
                      return null;
                    })()}
                    </TableCell>
                    <TableCell style={{ padding: '5px' }}>
                    {(() => {
                      const bciAnnotations = item.annotations && item.annotations.filter(annotation => annotation.annotationType === "belonging_centered_instruction");
                      if (bciAnnotations && bciAnnotations.length > 0) {
                        return bciAnnotations.map(a => `${a.values[0]} (${parseFloat(a.probability[1]).toFixed(2)})`).join(', ');
                      }
                      return null;
                    })()}
                    </TableCell>
                    <TableCell style={{ padding: '5px' }}>
                    {(() => {
                      const qtfAnnotations = item.annotations && item.annotations.filter(annotation => annotation.annotationType === "QTF");
                      if (qtfAnnotations && qtfAnnotations.length > 0) {
                        return qtfAnnotations.map(a => a.values[0]).join(', ');
                      }
                      return null;
                    })()}
                    </TableCell>
                  </TableRow>
                ))}
              </React.Fragment>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};

export default TranscriptTable;
